const Option = () => null;
Option.isSelectOption = true;
Option.displayName = 'ASelectOption';
export default Option;